export default function identity (x) {
  return x
}



// WEBPACK FOOTER //
// ./src/components-base/utils/identity.js